class ModalWindowGroup {
	constructor(identifier = "default") {
		this._identifier = identifier;
		this._children = [];
	}

	attach(modalWindowContainerElement, elmnt, layer = 0) {
		// const id = this._identifier + "_" + this._children.length;
		// TODO: We may need to reference this later if there is docking etc.
		// modalWindowContainerElement.setAttribute("modalwindow-id", id);
		// modalWindowContainerElement.setAttribute("modalwindow-group-id", this._identifier);
		// modalWindowContainerElement.setAttribute("modalwindow-group-child-index", this._childCount);

		this._children.push({
			container: modalWindowContainerElement,
			window: elmnt,
			layer: layer
		});
	}

	bringToTop(modalWindowContainerElement) {
		const index = this._children.findIndex((item) => {
			if (item.container === modalWindowContainerElement) {
				return true;
			}
			return false;
		});
		const thisData = this._children.splice(index, 1);
		this.attach(thisData[0].container, thisData[0].window, thisData[0].layer);
		// TODO: we should re-order all the attribute ids...?
		this.reorder();
	}

	reorder() {
		for (let i = 0; i < this._children.length; i++) {
			const layer = this._children[i].layer;
			this._children[i].window.style.zIndex = 100 + (layer * 10) + i;
		}
	}
}
export default ModalWindowGroup;
